import { Controller } from "@hotwired/stimulus";

// Docs::EditorComponent — toggles the Write / Preview panes.
// Preview rendering happens client-side as a no-op fallback that
// shows the textarea body inside a <pre> block; the canonical
// rendered preview is the saved doc's show page, which uses the
// server's Markdown::Renderer (link expansion included). For an
// in-flight draft we render plain text so operators see "what they
// typed" before saving.
export default class extends Controller {
  static targets = [
    "writeTab",
    "previewTab",
    "writePane",
    "previewPane",
    "body",
  ];

  showWrite(event) {
    event?.preventDefault();
    this.writePaneTarget.hidden = false;
    this.previewPaneTarget.hidden = true;
    this.writeTabTarget.setAttribute("aria-selected", "true");
    this.previewTabTarget.setAttribute("aria-selected", "false");
  }

  showPreview(event) {
    event?.preventDefault();
    this.writePaneTarget.hidden = true;
    this.previewPaneTarget.hidden = false;
    this.writeTabTarget.setAttribute("aria-selected", "false");
    this.previewTabTarget.setAttribute("aria-selected", "true");
    const body = this.hasBodyTarget ? this.bodyTarget.value : "";
    const pre = document.createElement("pre");
    pre.className = "whitespace-pre-wrap text-sm text-stone-800";
    pre.textContent = body;
    this.previewPaneTarget.replaceChildren(pre);
  }
}
